// SLIDERS

document.addEventListener( 'DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.splide-diag');
  let startValue = 2;

    sliders.forEach(function(slider) {
      new Splide( slider, {
          type   : 'slide',
          arrows: false,
          pagination: false,
          gap: 12,
          perPage: 4,
          destroy: true,
          breakpoints: {
            768: {
              destroy: false,
              pagination: true,
              perPage: 1,
              start: startValue,
              padding: {
                right: '60px',
                left: '60px'
              }
            }
          }
        }).mount();

        startValue = 1;
    })

} );

function mmDiagInputChange(activatedRadioInput) {
  const container = activatedRadioInput.closest('.mm-diag-step');
  container.classList.add('mm-activated');
}

function mmDiagInputChangeRemoveClass(activatedRadioInput) {
  const container = activatedRadioInput.closest('.mm-diag-step');
  container.classList.remove('mm-activated');
}

// TRANSITION ANIMS
function transitionAnimsOut(index) {
  // on prend tous les elements data-anim-slide-up
  const animatedElements = document.querySelectorAll(`.mm-diag-step-${index} [data-anim-slide-up]`);

  // on leur ajoute une class 'mm-animated-out'
  let delta = 0;
  animatedElements.forEach(function(animatedElement) {
    setTimeout(() => {
      animatedElement.classList.add('mm-animated-out');
    }, delta);

    delta += 100;
  })
  return delta;
}

function transitionAnimsIn(index) {
  // on prend tous les elements data-anim-slide-up
  const allAnimatedElements = document.querySelectorAll('[data-anim-slide-up]');
  const animatedElements = document.querySelectorAll(`.mm-diag-step-${index} [data-anim-slide-up]`);

  // on leur ajoute une class 'mm-animated-in'
  allAnimatedElements.forEach(function(allAnimatedElement) {
      allAnimatedElement.classList.remove('mm-animated-out');
  })

  animatedElements.forEach(function(animatedElement) {
    animatedElement.classList.add('mm-animated-in');
  })
  // .5s après, on leur enleve la class 'mm-animated-in'
  let delta = 100;
  animatedElements.forEach(function(animatedElement) {
    setTimeout(() => {
      animatedElement.classList.remove('mm-animated-in');
    }, (delta));
    delta += 100;
  })
}

function mmDiagChangeStep(currentIndex, direction) {
  const currentStepElement = document.querySelector(`.mm-diag-step-${currentIndex}`);
  const targetIndex = currentIndex + direction;
  const targetStepElement = document.querySelector(`.mm-diag-step-${targetIndex}`);
  const oldPage = document.querySelector(`.mm-diag-pagination-element[data-index="${currentIndex}"]`);
  const newPage = document.querySelector(`.mm-diag-pagination-element[data-index="${targetIndex}"]`);

  const delta = transitionAnimsOut(currentIndex);

  setTimeout(() => {
    currentStepElement?.classList.remove('mm-active');
    targetStepElement?.classList.add('mm-active');
    transitionAnimsIn(targetIndex);

    // Vérifier l'état des inputs si on arrive à l'étape 2
    if (targetIndex === 2) {
      setTimeout(() => {
        mmCheckStep2Inputs();
      }, 100);
    }
  }, (delta + 500));

  if (direction === -1) {
    oldPage?.classList.remove('mm-active');
    newPage?.classList.remove('mm-old');
  } else if (direction === 1) {
    oldPage?.classList.add('mm-old');
    newPage?.classList.add('mm-active');
  }
}

// Pour revenir à l'étape précédente
function mmDiagPrevStep(currentIndex) {
  mmDiagChangeStep(currentIndex, -1);
}

// Pour aller à l'étape suivante
function mmDiagNextStep(currentIndex, updateTags = false) {
  // Vérifier si on est à l'étape 2 et si les inputs sont remplis
  if (currentIndex === 2) {
    const nextButton = document.querySelector('.mm-next-diag-btn-opacity');
    if (nextButton && nextButton.style.pointerEvents === 'none') {
      return; // Ne pas passer à l'étape suivante si le bouton est désactivé
    }
  }

  mmDiagChangeStep(currentIndex, 1);

  // If last step - recap
  if (updateTags) {
    mmUpdateTags();
  }
}

function mmUpdateTags() {
    const tagsContainer = document.querySelector('.mm-diag-step-recap-container-tags');
    tagsContainer.innerHTML = `
      <span class="mm-diag-step-recap-container-tag">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.89556 8.70508C5.60267 8.41219 5.1278 8.41219 4.8349 8.70508C4.54201 8.99797 4.54201 9.47285 4.8349 9.76574L5.89556 8.70508ZM7.25273 11.1229L6.7224 11.6532C6.86306 11.7939 7.05382 11.8729 7.25273 11.8729C7.45165 11.8729 7.64241 11.7939 7.78306 11.6532L7.25273 11.1229ZM12.1872 7.24908C12.4801 6.95619 12.4801 6.48131 12.1872 6.18842C11.8943 5.89553 11.4195 5.89553 11.1266 6.18842L12.1872 7.24908ZM4.8349 9.76574L6.7224 11.6532L7.78306 10.5926L5.89556 8.70508L4.8349 9.76574ZM7.78306 11.6532L12.1872 7.24908L11.1266 6.18842L6.7224 10.5926L7.78306 11.6532Z" fill="#00755B"/>
        </svg>
        ${localStorage.getItem("deplacement")}
      </span>
       <span class="mm-diag-step-recap-container-tag">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.89556 8.70508C5.60267 8.41219 5.1278 8.41219 4.8349 8.70508C4.54201 8.99797 4.54201 9.47285 4.8349 9.76574L5.89556 8.70508ZM7.25273 11.1229L6.7224 11.6532C6.86306 11.7939 7.05382 11.8729 7.25273 11.8729C7.45165 11.8729 7.64241 11.7939 7.78306 11.6532L7.25273 11.1229ZM12.1872 7.24908C12.4801 6.95619 12.4801 6.48131 12.1872 6.18842C11.8943 5.89553 11.4195 5.89553 11.1266 6.18842L12.1872 7.24908ZM4.8349 9.76574L6.7224 11.6532L7.78306 10.5926L5.89556 8.70508L4.8349 9.76574ZM7.78306 11.6532L12.1872 7.24908L11.1266 6.18842L6.7224 10.5926L7.78306 11.6532Z" fill="#00755B"/>
        </svg>
         ${translations.footLength} : ${localStorage.getItem("longueur")}cm
      </span>
      <span class="mm-diag-step-recap-container-tag">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.89556 8.70508C5.60267 8.41219 5.1278 8.41219 4.8349 8.70508C4.54201 8.99797 4.54201 9.47285 4.8349 9.76574L5.89556 8.70508ZM7.25273 11.1229L6.7224 11.6532C6.86306 11.7939 7.05382 11.8729 7.25273 11.8729C7.45165 11.8729 7.64241 11.7939 7.78306 11.6532L7.25273 11.1229ZM12.1872 7.24908C12.4801 6.95619 12.4801 6.48131 12.1872 6.18842C11.8943 5.89553 11.4195 5.89553 11.1266 6.18842L12.1872 7.24908ZM4.8349 9.76574L6.7224 11.6532L7.78306 10.5926L5.89556 8.70508L4.8349 9.76574ZM7.78306 11.6532L12.1872 7.24908L11.1266 6.18842L6.7224 10.5926L7.78306 11.6532Z" fill="#00755B"/>
        </svg>
        ${translations.footWidth} : ${localStorage.getItem("largeur")}cm
      </span>
      <span class="mm-diag-step-recap-container-tag">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.89556 8.70508C5.60267 8.41219 5.1278 8.41219 4.8349 8.70508C4.54201 8.99797 4.54201 9.47285 4.8349 9.76574L5.89556 8.70508ZM7.25273 11.1229L6.7224 11.6532C6.86306 11.7939 7.05382 11.8729 7.25273 11.8729C7.45165 11.8729 7.64241 11.7939 7.78306 11.6532L7.25273 11.1229ZM12.1872 7.24908C12.4801 6.95619 12.4801 6.48131 12.1872 6.18842C11.8943 5.89553 11.4195 5.89553 11.1266 6.18842L12.1872 7.24908ZM4.8349 9.76574L6.7224 11.6532L7.78306 10.5926L5.89556 8.70508L4.8349 9.76574ZM7.78306 11.6532L12.1872 7.24908L11.1266 6.18842L6.7224 10.5926L7.78306 11.6532Z" fill="#00755B"/>
        </svg>
        ${localStorage.getItem("cheville")}
      </span>
      <span class="mm-diag-step-recap-container-tag">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.89556 8.70508C5.60267 8.41219 5.1278 8.41219 4.8349 8.70508C4.54201 8.99797 4.54201 9.47285 4.8349 9.76574L5.89556 8.70508ZM7.25273 11.1229L6.7224 11.6532C6.86306 11.7939 7.05382 11.8729 7.25273 11.8729C7.45165 11.8729 7.64241 11.7939 7.78306 11.6532L7.25273 11.1229ZM12.1872 7.24908C12.4801 6.95619 12.4801 6.48131 12.1872 6.18842C11.8943 5.89553 11.4195 5.89553 11.1266 6.18842L12.1872 7.24908ZM4.8349 9.76574L6.7224 11.6532L7.78306 10.5926L5.89556 8.70508L4.8349 9.76574ZM7.78306 11.6532L12.1872 7.24908L11.1266 6.18842L6.7224 10.5926L7.78306 11.6532Z" fill="#00755B"/>
        </svg>
        ${localStorage.getItem("epaisseur")}
      </span>
      <span class="mm-diag-step-recap-container-tag">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.89556 8.70508C5.60267 8.41219 5.1278 8.41219 4.8349 8.70508C4.54201 8.99797 4.54201 9.47285 4.8349 9.76574L5.89556 8.70508ZM7.25273 11.1229L6.7224 11.6532C6.86306 11.7939 7.05382 11.8729 7.25273 11.8729C7.45165 11.8729 7.64241 11.7939 7.78306 11.6532L7.25273 11.1229ZM12.1872 7.24908C12.4801 6.95619 12.4801 6.48131 12.1872 6.18842C11.8943 5.89553 11.4195 5.89553 11.1266 6.18842L12.1872 7.24908ZM4.8349 9.76574L6.7224 11.6532L7.78306 10.5926L5.89556 8.70508L4.8349 9.76574ZM7.78306 11.6532L12.1872 7.24908L11.1266 6.18842L6.7224 10.5926L7.78306 11.6532Z" fill="#00755B"/>
        </svg>
        ${mmGetLargeurTagText()}
      </span>
    `
}

function mmGetLargeurTagText() {
  const tag = localStorage.getItem("largeur_tag");
  return document.querySelector(`.mm-diag-data-foot-width-tag[data-tag="${tag}"]`).dataset.tagText;
}

function checkInputs() {
    // Sélectionner tous les éléments avec la classe 'decimalInput'
    const diag = document.querySelector('.mm-diag-container');
    const inputs = diag.querySelectorAll('.decimalInput');
    let allNonZero = true;

    // Utiliser forEach pour parcourir les inputs
    inputs.forEach(input => {
        if (input.classList.contains('mm-diag-length')) {
          const value = parseFloat(input.value);
          if (input.value.trim() === '' || isNaN(value) || value === 7 || value === 7.0) {
              allNonZero = false;
          }
        }
        if (input.classList.contains('mm-diag-width')) {
          const value = parseFloat(input.value);
          if (input.value.trim() === '' || isNaN(value) || value === 3 || value === 3.0) {
              allNonZero = false;
          }
        }
    });

    // Si toutes les valeurs sont différentes de 0, déclencher la fonction
    if (allNonZero) {
        mmDiagInputChange(inputs[0]);
    } else {
        mmDiagInputChangeRemoveClass(inputs[0]);
    }
}

// OPACITY ON FEET BARS
function opacityOnFeetBars() {
  const triggerElems = document.querySelectorAll('.mm-diag-step2-slider-container');
  const bars = document.querySelectorAll('.mm-diag-step2-block-bar');

  triggerElems.forEach(function(triggerElem) {
    triggerElem.addEventListener('mouseenter', function() {
      bars.forEach(function(bar) {
        bar.style.opacity = '0.3';
      })
      document.querySelector(triggerElem.dataset.bar).style.opacity = '1';
    })
    triggerElem.addEventListener('mouseleave', function() {
      bars.forEach(function(bar) {
        bar.style.opacity = '0.3';
      })
    })
  })
}

function mmChangeLocalStorageData(key, value) {
  // Vérifie si la clé existe dans le localStorage
  if (localStorage.getItem(key) !== null) {
    // La clé existe, on met à jour sa valeur
    localStorage.setItem(key, value);
  } else {
    // La clé n'existe pas, on la crée avec la valeur donnée
    localStorage.setItem(key, value);
  }
}

function mmChangeLocalStorageDataForFootSize(classElems, storageName, sideInput) {
  const inputs = document.querySelectorAll(classElems);

  let values = [];

  inputs.forEach(function(input) {
    values.push(input.value);
  })

  let maxLength = Math.max(...values);

  mmChangeLocalStorageData(storageName, maxLength);

  mmShowDiagAlert();
  mmCheckStep2Inputs();
}

function mmShowDiagAlert() {
  const decimalInputs = document.querySelectorAll('.decimalInput.mm-diag-length');
  const tooltip = document.querySelector('.mm-diag-step-error');
  const lengthInputs = document.querySelectorAll('.mm-diag-length');
  let values = [];

  lengthInputs.forEach(function(input) {
    const value = parseFloat(input.value);
    // On inclut toutes les valeurs valides (y compris les valeurs par défaut 7)
    if(!isNaN(value) && input.value.trim() !== '') {
      values.push(value);
    }
  })

  // Il y a 2 inputs de longueur (gauche et droite), on vérifie quand on a 2 valeurs valides
  if(values.length === 2) {
    let minLength = Math.min(...values);
    let maxLength = Math.max(...values);
    const ecart = maxLength - minLength;

    if(ecart > 0.4) {
      tooltip.classList.add('mm-visible');
      decimalInputs.forEach(function(decimalInput) {
        decimalInput.closest('.input-container').classList.add('mm-activated');
      })
      // Désactiver le bouton si l'erreur est visible
      mmCheckStep2Inputs();
    } else {
      tooltip.classList.remove('mm-visible');
      decimalInputs.forEach(function(decimalInput) {
        decimalInput.closest('.input-container').classList.remove('mm-activated');
      })
      // Réactiver le bouton si l'erreur n'est plus visible
      mmCheckStep2Inputs();
    }
  } else {
    // Si on n'a pas encore 2 valeurs valides, on cache l'erreur
    tooltip.classList.remove('mm-visible');
    decimalInputs.forEach(function(decimalInput) {
      decimalInput.closest('.input-container').classList.remove('mm-activated');
    })
  }
}

function mmCloseDiagAlert() {
  const tooltip = document.querySelector('.mm-diag-step-error');
  tooltip.classList.remove('mm-visible');
  // Réactiver le bouton après avoir fermé l'erreur
  mmCheckStep2Inputs();
}

function mmCheckStep2Inputs() {
  const nextButton = document.querySelector('.mm-next-diag-btn-opacity');
  if (!nextButton) return;

  const lengthInputs = document.querySelectorAll('.mm-diag-length');
  const widthInputs = document.querySelectorAll('.mm-diag-width');
  const errorTooltip = document.querySelector('.mm-diag-step-error');
  const hasError = errorTooltip && errorTooltip.classList.contains('mm-visible');

  let allFilled = true;

  // Vérifier les inputs de longueur
  lengthInputs.forEach(function(input) {
    const value = parseFloat(input.value);
    if (isNaN(value) || input.value.trim() === '' || value === 7 || value === 7.0) {
      allFilled = false;
    }
  });

  // Vérifier les inputs de largeur
  widthInputs.forEach(function(input) {
    const value = parseFloat(input.value);
    if (isNaN(value) || input.value.trim() === '' || value === 3 || value === 3.0) {
      allFilled = false;
    }
  });

  // Appliquer l'opacity et désactiver/activer le clic
  // Le bouton doit être désactivé si les inputs ne sont pas remplis OU si l'erreur est visible
  if (allFilled && !hasError) {
    nextButton.style.opacity = '1';
    nextButton.style.pointerEvents = 'auto';
    nextButton.style.cursor = 'pointer';
  } else {
    nextButton.style.opacity = '0.5';
    nextButton.style.pointerEvents = 'none';
    nextButton.style.cursor = 'not-allowed';
  }
}

document.addEventListener("DOMContentLoaded", function() {
  opacityOnFeetBars();

  // Ajouter la validation en temps réel pour les inputs de longueur
  const lengthInputs = document.querySelectorAll('.mm-diag-length');
  lengthInputs.forEach(function(input) {
    input.addEventListener('input', function() {
      mmShowDiagAlert();
      mmCheckStep2Inputs();
    });
  });

  // Ajouter la validation en temps réel pour les inputs de largeur
  const widthInputs = document.querySelectorAll('.mm-diag-width');
  widthInputs.forEach(function(input) {
    input.addEventListener('input', function() {
      mmCheckStep2Inputs();
    });
  });

  // Vérifier l'état initial des inputs si l'étape 2 est active
  const step2 = document.querySelector('.mm-diag-step-2.mm-active');
  if (step2) {
    setTimeout(() => {
      mmCheckStep2Inputs();
    }, 100);
  }
})

// Show Diag
function mmToggleDiag() {
  const diag = document.querySelector('.mm-section-diag-popup');
  diag.classList.toggle('mm-open');
}

// Show Video
function mmDiagShowVideo(videoHtmlElement) {
  document.querySelector('.mm-diag-video-filter').classList.add('mm-visible');
  document.querySelector('.mm-diag-video-element-container').innerHTML = videoHtmlElement;
}

function mmDiagCloseVideo() {
  document.querySelector('.mm-diag-video-filter').classList.remove('mm-visible');
  document.querySelector('.mm-diag-video-element-container').innerHTML = '';
}

// GENERATE FINAL URL
function generateUrl() {
  const CTA = document.querySelector('.mm-diag-step-5 .mm-btn-secondary');

  //TAGS OK
  const deplacementTag = localStorage.getItem('deplacementTag');
  const chevilleTag = localStorage.getItem('chevilleTag');
  const epaisseurTag = localStorage.getItem('epaisseurTag');
  const largeurTag = localStorage.getItem('largeur_tag');

  // CREATE URL
  const currentUrl = window.location.pathname;
  let url;
  if (currentUrl.startsWith('/es')) {
      url = `/es/collections/all?filter.p.m.custom.mm_motricite=${deplacementTag}&filter.p.m.custom.mm_epaisseur_des_chevilles=${chevilleTag}&filter.p.m.custom.mm_epaisseur_des_pieds=${epaisseurTag}&filter.p.m.custom.mm_largeur_des_pieds=${largeurTag}&filter.v.availability=1&load_values=true`
  } else {
      url = `/collections/all?filter.p.m.custom.mm_motricite=${deplacementTag}&filter.p.m.custom.mm_epaisseur_des_chevilles=${chevilleTag}&filter.p.m.custom.mm_epaisseur_des_pieds=${epaisseurTag}&filter.p.m.custom.mm_largeur_des_pieds=${largeurTag}&filter.v.availability=1&load_values=true`
  }

  mmChangeLocalStorageData('diag_url', url);
  CTA.href = url;
}


function footWidthDiagReturnTag() {

  const width = localStorage.getItem('largeur');
  const length = localStorage.getItem('longueur');
  const ratio = length / width;

  const tagsInput = document.querySelector('.mm-diag-data-foot-width-tags');
  const tag1 = tagsInput.dataset.tag1;
  const tag2 = tagsInput.dataset.tag2;
  const tag3 = tagsInput.dataset.tag3;

  let steps = [];
  let stepsElems = [];
  document.querySelectorAll('.mm-diag-data-foot-width-steps').forEach(function(elem) {
    stepsElems.push(elem);
    steps.push(elem.value);
  })

  const low_size = steps[0];
  const mid_size = steps[1];
  const high_size = steps[2];
  const inf_size = steps[3];

  const low_size_elem = stepsElems[0];
  const mid_size_elem = stepsElems[1];
  const high_size_elem = stepsElems[2];
  const inf_size_elem = stepsElems[3];

  if (length < low_size) {
    const low_step = low_size_elem.dataset.lowStep;
    const high_step = low_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      return tag1;
    } else if (ratio <= high_step) {
      return tag2;
    } else if (ratio > high_step) {
      return tag3;
    }
  } else if (length < mid_size) {
    const low_step = mid_size_elem.dataset.lowStep;
    const high_step = mid_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      return tag1;
    } else if (ratio <= high_step) {
      return tag2;
    } else if (ratio > high_step) {
      return tag3;
    }
  } else if (length < high_size) {
    const low_step = high_size_elem.dataset.lowStep;
    const high_step = high_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      return tag1;
    } else if (ratio <= high_step) {
      return tag2;
    } else if (ratio > high_step) {
      return tag3;
    }
  } else if (length >= high_size) {
    const low_step = inf_size_elem.dataset.lowStep;
    const high_step = inf_size_elem.dataset.highStep;

    if (ratio <= low_step) {
      return tag1;
    } else if (ratio <= high_step) {
      return tag2;
    } else if (ratio > high_step) {
      return tag3;
    }
  }
}

// INIT IF ALREADY VISITED
function initIfAlreadyVisited() {
  if (localStorage.getItem('diag_url')) {
    document.querySelector('.mm-diag-step-1').classList.remove('mm-active');
    document.querySelector('.mm-diag-step-5').classList.add('mm-active');
    document.querySelectorAll('.mm-diag-pagination-element').forEach(function(elem) {
      elem.classList.add('mm-active');
    })
    document.querySelector('.mm-diag-step-5 .mm-btn-secondary ').href = localStorage.getItem('diag_url');
    mmUpdateTags();
  }
}

function goBackToStepOne() {
  document.querySelector('.mm-diag-step-1').classList.add('mm-active');
  document.querySelector('.mm-diag-step-5').classList.remove('mm-active');

  // Reset pagination
  document.querySelectorAll('.mm-diag-pagination-element').forEach(function(elem) {
    elem.classList.remove('mm-active');
    elem.classList.remove('mm-old');
  })
  document.querySelectorAll('.mm-diag-pagination-element')[0].classList.add('mm-active');

  // Reset CTAs
  document.querySelectorAll('.mm-diag-container .mm-diag-step.mm-activated').forEach(function(elem) {
    elem.classList.remove('mm-activated');
  })

  // Reset all localStorage Data
  localStorage.removeItem('diag_url');
  localStorage.removeItem('largeur');
  localStorage.removeItem('longueur');
  localStorage.removeItem('cheville');
  localStorage.removeItem('chevilleTag');
  localStorage.removeItem('chevilleIndex');
  localStorage.removeItem('deplacement');
  localStorage.removeItem('epaisseur');
  localStorage.removeItem('deplacementIndex');
  localStorage.removeItem('epaisseurTag');
  localStorage.removeItem('deplacementTag');
  localStorage.removeItem('largeur_tag');
  localStorage.removeItem('epaisseurIndex');

  // Reset all fields
  const checkedInputs = document.querySelectorAll('.mm-diag-container input:checked');
  checkedInputs.forEach(function(checkedInput) {
    checkedInput.checked = false;
  })
  const decimalInputs = document.querySelectorAll('.mm-diag-container .decimalInput');
  decimalInputs.forEach(function(decimalInput) {
    const eventInput = new Event("input");
    const eventBlur = new Event("blur");
    // Ne pas réinjecter une "valeur par défaut" (min=7/min=3) : on veut un champ vide
    decimalInput.value = '';
    decimalInput.dispatchEvent(eventInput);
    decimalInput.dispatchEvent(eventBlur);
  })

  // Remove error
  document.querySelector('.mm-diag-step-error').classList.remove('mm-visible')


}

initIfAlreadyVisited();
